import React, { useState } from 'react';

import ProjectSettingsSwitches from './project-components/ProjectSettingsSwitches';
import ClientImageSelect from '../../components/DemoTabs/ClientImageSelect';

import SingleSelectSetOwner from '../../components/Projects/project-components/SingleSelectSetOwner';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    Avatar,
    InputLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';



const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};


const EditProject = ({ open, onClose }) => {

    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 

    // start Projects 
    const [selectedClients, setSelectedClients] = React.useState([]);
    const allClients = [
        { name: 'Client Name 1', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Client Name 2', image: null },
        { name: 'Client Name 3', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Client Name 4', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Client Name 5', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Client Name 6', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];
    // End Projects 


    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0', }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Edit project</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>

                    <Box display="flex" alignItems="center" sx={{ gap: '8px', margin:'0 auto 32px' }}>
                        <Avatar sx={{ height: '42px', width: '42px', fontSize: '14px', backgroundColor: '#5932EA', color: '#fff', fontFamily:'Manrope' }}>
                            <span>SG</span>
                            {/* <img src="./assets/images/insights/file/project-icon.svg" alt='project icon' style={{
                                    height: '42px', width: '42px',
                                    backgroundSize: 'cover', objectFit: 'cover' className="img-fluid" /> */}
                        </Avatar>
                        <Box>
                            <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>Sky Grid</Typography>
                            <Typography fontSize={'14px'} color='#64748B' fontWeight={'400'} sx={{fontFamily:'Manrope'}}>Worked Desk 1</Typography>
                        </Box>
                    </Box>

                    <Typography display="flex" alignItems="center" className='fw-semibold' color="#0076FE" sx={{ fontSize: '16px', gap: '10px', lineHeight: '1', fontFamily: 'Manrope' }} gutterBottom>
                        <span><img src="./assets/images/insights/file/general-icon.svg" alt='General Icon' className="img-fluid" /></span>
                        General</Typography>
                    <Box sx={{ m: '24px auto 24px' }}>
                        <Box sx={{ m: '0 auto 0' }}>
                            <Typography color='#1A1F36' fontWeight={600} mb={'6px'} sx={{ fontSize: '14px', fontWeight: '600', lineHeight: '1', fontFamily: 'Manrope' }}>Project Names*
                                <Tooltip title="Create multiple projects by adding project names on separate lines" arrow placement="top">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" sx={{ width: '12px', height: '12px', margin: '0 0 1px 4px ' }} />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <TextField fullWidth placeholder="Add Project Names " variant="outlined" margin="normal"
                                sx={{
                                    marginTop: '0', fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                        height: '40px', fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily: 'Manrope' },
                                }} />
                            <TextField fullWidth multiline rows={3} placeholder="Description" variant="outlined"
                                sx={{
                                    marginTop: '0', fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                        fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '0px 0px', fontFamily: 'Manrope' },
                                }} />
                        </Box>
                    </Box>
                    {/* start Toggle Sec */}
                    <ProjectSettingsSwitches />
                    {/* End Toggle Sec */}
                    <Box>

                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#000', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Clients</InputLabel>
                        <ClientImageSelect label="All Clients" options={allClients} selectedValues={selectedClients} onChange={setSelectedClients} />
                    </Box>

                    <Button
                        startIcon={<img src='./assets/images/app-activity/projects/icons/add-member-icon.svg' className='img-fluid' alt='Budget Icon' />}
                        sx={{
                            mt: '24px',
                            mb: '24px',
                            p: '0',
                            color: 'primary.main',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '16px',
                            fontFamily: 'Manrope'
                        }}
                    >
                        Add Members
                    </Button>

                    <Box>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Members</InputLabel>
                        <SingleSelectSetOwner selectedProject={selectedProject} setSelectedProject={setSelectedProject} />

                    </Box>
                    <Button startIcon={<img src='./assets/images/app-activity/projects/icons/budget-icon.svg' className='img-fluid' alt='Budget Icon' />}
                        sx={{
                            mt: '10px',
                            mb: '24px',
                            p: '0',
                            color: 'primary.main',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '16px',
                            fontFamily: 'Manrope'
                        }}
                    >
                        Budget & Limits
                    </Button>


                    <Box sx={{ backgroundColor: '#0076FE0A', border: '1px solid #0076FE', borderRadius: '8px', padding: '20px 12px' }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '10px', fontSize: '16px', fontWeight: '500', color: '#0076FE', fontFamily: 'Manrope' }}><img src='./assets/images/app-activity/projects/icons/lock-icon.svg' className='img-fluid' alt='Budget Icon' />Project Budgets is a Premium Feature</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '400', margin: '8px auto 32px', fontFamily: 'Manrope' }}>Set budgets for projects based on hours, bill rates, or pay rates. Get automatic alerts as you approach limits and track spending in real time.</Typography>

                        <Button color="primary" className='text-capitalize' sx={{ color: '#fff', fontFamily: 'Manrope', backgroundColor: '#0076FE', p: '10px 24px', fontSize: '16px', fontWeight: '500', height: '40px', border: 'none', borderRadius: '100px' }}>
                            Upgrade to Unlock Budgets
                        </Button>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default EditProject;
